import { c as _c } from "react/compiler-runtime";
import { type LucideIcon } from 'lucide-react';
import { type Route } from 'next';
import { ActivePath } from '@/components/active-path';
import { Badge } from '@/components/ui/badge';
import { Separator } from '@/components/ui/separator';
import { SidebarGroup, SidebarGroupLabel, SidebarMenu, SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar';
import { cn } from '@/lib/utils';
import Link from 'next/link';
function NavMainItem(t0) {
  const $ = _c(14);
  const {
    item,
    isActive: t1
  } = t0;
  const isActive = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== isActive) {
    t2 = cn("h-9 px-3 gap-3 text-muted-foreground font-medium text-sm rounded-lg", {
      "bg-linear-to-r from-purple-400 to-purple-500 text-white hover:text-white active:text-white/75 shadow-lg shadow-purple-400/25": isActive
    });
    $[0] = isActive;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = !!item.href;
  let t4;
  if ($[2] !== isActive || $[3] !== item.badge || $[4] !== item.color || $[5] !== item.disabled || $[6] !== item.href || $[7] !== item.icon || $[8] !== item.title) {
    t4 = item.href ? <Link href={item.href} className={cn("flex w-full items-center gap-3", {
      "cursor-pointer": !item.disabled,
      "pointer-events-none opacity-50": item.disabled
    })}>{item.icon && <item.icon className={cn("size-5! group-data-[collapsible=icon]:size-4!", isActive ? "text-white" : item.color)} />}<span className="truncate">{item.title}</span>{item.badge ? <><div className="grow" /><Badge variant="secondary" className="text-muted-foreground">{item.badge}</Badge></> : null}</Link> : <div className={cn("flex w-full items-center gap-3", {
      "cursor-pointer": !item.disabled,
      "pointer-events-none opacity-50": item.disabled
    })}>{item.icon && <item.icon className={cn("size-5! group-data-[collapsible=icon]:size-4!", isActive ? "text-white" : item.color)} />}<span className="truncate">{item.title}</span>{item.badge ? <><div className="grow" /><Badge variant="secondary" className="text-muted-foreground">{item.badge}</Badge></> : null}</div>;
    $[2] = isActive;
    $[3] = item.badge;
    $[4] = item.color;
    $[5] = item.disabled;
    $[6] = item.href;
    $[7] = item.icon;
    $[8] = item.title;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
    t5 = <SidebarMenuItem><SidebarMenuButton className={t2} asChild={t3}>{t4}</SidebarMenuButton></SidebarMenuItem>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}
export function NavMain(t0) {
  const $ = _c(4);
  const {
    groups
  } = t0;
  let t1;
  if ($[0] !== groups) {
    t1 = groups.map(_temp2);
    $[0] = groups;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <>{t1}</>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp2(group, index) {
  return <div key={index} className="flex flex-col gap-2">{index > 0 && <div className="mx-5"><Separator orientation="horizontal" /></div>}<SidebarGroup><SidebarGroupLabel className="mx-1 py-2 text-xs font-medium text-gray-400 dark:text-gray-600 uppercase tracking-wide">{group.title}</SidebarGroupLabel><SidebarMenu>{group.items?.map(_temp)}</SidebarMenu></SidebarGroup></div>;
}
function _temp(item) {
  return item.href ? <ActivePath key={item.href} path={item.href} active={<NavMainItem item={item} isActive={true} />} inactive={<NavMainItem item={item} />} /> : <NavMainItem key={item.title} item={item} />;
}